import { storefrontDeliveryEstimateSchema } from "@redotech/redo-model/conversion/storefront-delivery-estimate";
import * as z from "zod/v4";

export const getStorefrontDeliveryEstimateSettings = {
  name: "getStorefrontDeliveryEstimateSettings" as const,
  input: z.null(),
  output: z.object({ settings: storefrontDeliveryEstimateSchema.optional() }),
};
